import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { filter } from 'rxjs/operators';
import { TitleConfigService } from './title-config.service';

@Injectable({
  providedIn: 'root',
})
export class LandingPageService {
  private subject = new BehaviorSubject<{ urlAfterRedirects: string; }>({
    urlAfterRedirects: '',
  });
  public $landed = this.subject.asObservable();

  constructor(
    private router: Router,
    private titleService: TitleConfigService
  ) {
    this.router.events
      .pipe(
        filter(
          (event): event is NavigationEnd => event instanceof NavigationEnd
        )
      )
      .subscribe((event) => this.land(event.urlAfterRedirects));
  }

  private async land(urlAfterRedirects: string): Promise<void> {
    await this.titleService.load(urlAfterRedirects);

    this.next({
      urlAfterRedirects,
    });
  }

  private next(event: { urlAfterRedirects: string; }): void {
    this.subject.next(event);
  }
}
